import styled from "styled-components";
import { CSSProperties } from "react";

export const ModalBody = styled.div`
  padding: 28px 28px 24px;
  text-align: center;
  background: #ffffff;
  border-radius: 12px;
`;

export const SuccessIconWrap = styled.div`
  display: flex;
  justify-content: center;
  margin-bottom: 12px;
`;

export const Title = styled.h2`
  margin: 0 0 8px;
  font-size: 1.35rem;
  font-weight: 700;
  color: #111827;
`;

export const Subtitle = styled.p`
  margin: 0 0 6px;
  font-size: 0.95rem;
  color: #374151;
`;

export const Note = styled.p`
  margin: 0;
  font-size: 0.85rem;
  color: #b45309;
`;

export const Divider = styled.hr`
  margin: 20px 0;
  border: 0;
  border-top: 1px solid #e5e7eb;
`;

export const PitchTitle = styled.h3`
  margin: 0 0 8px;
  font-size: 1.05rem;
  font-weight: 600;
  color: #111827;
`;

export const PitchBody = styled.p`
  margin: 0 0 20px;
  font-size: 0.9rem;
  line-height: 1.45;
  color: #6b7280;
`;

export const Actions = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

export const primaryButtonStyle: CSSProperties = {
  backgroundColor: "#14b8a6",
  borderColor: "#14b8a6",
  color: "#ffffff",
  fontWeight: 600,
  padding: "10px 16px",
  borderRadius: 8,
};

export const secondaryButtonStyle: CSSProperties = {
  color: "#6b7280",
  textDecoration: "none",
  fontWeight: 500,
  marginTop: 4,
};
